import { IMultiSelectOptions, IRadioButtonItem, MultiSelectFormik, RadioButtonFormik } from "@starrez/starryui";
import React from "react";
import { IParticipant, IParticipantSelectorProps, ParticipantSelectType } from ".";
import { strings } from "../../../../../localisation";
import { ExecuteModel } from "../../../../Steps/ExecuteModel";
import { IParticipantEmailDataModel } from "../../../models/ParticipantEmail";
import { ParticipantRadioDiv } from "./ParticipantSelector.styles";

export const ParticipantSelector = ({
    FieldLabel,
    FieldGroup,

    SelectionTypeOptions,
    Participants,

    FormikProps,
    Required,
}: IParticipantSelectorProps) => {

    // State
    const [participantDropDownDisabled, SetParticipantDropDownDisabled] = React.useState(true);

    React.useEffect(() => {
        const selectedOption = FormikProps?.values.formDataModel.ParticipantSelectorOptions;

        if (participantDropDownDisabled && (selectedOption && selectedOption === ParticipantSelectType.SelectedParticipants)) {
            SetParticipantDropDownDisabled(false);
        } else if (!participantDropDownDisabled && (selectedOption && selectedOption !== ParticipantSelectType.SelectedParticipants)) {
            SetParticipantDropDownDisabled(true);
        }
    }, [FormikProps?.values.formDataModel.ParticipantSelectorOptions]);

    // Update ParticipantField
    React.useEffect(() => {
        if (FormikProps) {
            const ids = FormikProps?.values.formDataModel.ParticipantSelectItems?.map((item: IMultiSelectOptions) => item.value);
            FormikProps.setFieldValue(
                nameof.full<ExecuteModel<IParticipantEmailDataModel>>((m) => m.formDataModel.ParticipantEntryIDs), ids ?? []);
        }
    }, [FormikProps?.values.formDataModel.ParticipantSelectItems]);

    // Radio Button Options
    const selectionOptions: IRadioButtonItem[] = React.useMemo(() => {
        if (SelectionTypeOptions) {
            return Object.entries(SelectionTypeOptions).map<IRadioButtonItem>(([selectType, selectLabel]) => {
                return {
                    Value: selectType,
                    Label: selectLabel || strings.Empty,
                };
            });
        } else {
            return [
                { Value: ParticipantSelectType.All, Label: strings.Label_ParticipantSelector_SendToAllInvolved },
                { Value: ParticipantSelectType.AllParticipants, Label: strings.Label_ParticipantSelector_SendToAllParticipants },
                { Value: ParticipantSelectType.SelectedParticipants, Label: strings.Label_ParticipantSelector_SendToSpecificParticipants },
            ];
        }
    }, []);

    // Participant Multiselect
    const participantOptions: IMultiSelectOptions[] = React.useMemo(() => {
        return Participants.map<IMultiSelectOptions>((participant: IParticipant) => {
            return { label: participant.name, value: participant.participantID };
        });
    }, [Participants]);

    const typeSelectionHasError = (
        FormikProps?.errors?.formDataModel?.ParticipantSelectorOptions !== undefined &&
        FormikProps?.touched?.formDataModel?.ParticipantSelectorOptions !== undefined
    ) ?? false;

    const showParticipantDropdown: boolean = selectionOptions.some((opt) => opt.Value === ParticipantSelectType.SelectedParticipants);

    return (
        <>
            <ParticipantRadioDiv HasError={typeSelectionHasError} HasParticipants={showParticipantDropdown} >
                <RadioButtonFormik
                    FormikProps={FormikProps}
                    Name={nameof.full<ExecuteModel<IParticipantEmailDataModel>>((m) => m.formDataModel.ParticipantSelectorOptions)}
                    Label={FieldLabel}
                    Group={FieldGroup || FieldLabel}
                    GroupId={FieldGroup || FieldLabel}
                    ShowRequired={Required}
                    Items={selectionOptions}
                    Disabled={selectionOptions.length < 1}
                    HelperText={typeSelectionHasError ? FormikProps!.errors.formDataModel?.ParticipantSelectorOptions : strings.Empty}
                />
            </ParticipantRadioDiv>

            {/* Only show if the SendToSpecificParticipants option is available */}
            {showParticipantDropdown &&
                <MultiSelectFormik
                    FormikProps={FormikProps}
                    Name={nameof.full<ExecuteModel<IParticipantEmailDataModel>>((m) => m.formDataModel.ParticipantSelectItems)}
                    Label={strings.Empty}
                    Options={participantOptions}
                    HelperText={strings.Label_ParticipantSelector_SelectParticipants}
                    Disabled={participantDropDownDisabled}
                    Autocomplete="participant-selector"
                />
            }
        </>
    );
};
